import { apiPost, apiPatch, apiDelete } from "./client";

export function postAuthorizenetTransaction(data) {
  return apiPost("/authorizenet/", data);
}

export function postAuthorizenetArb(data) {
  return apiPost("/authorizenet/arb/", data);
}

export function patchAuthorizenetArb(data) {
  return apiPatch("/authorizenet/arb/", data);
}

export function deleteAuthorizenetArb(data) {
  return apiDelete("/authorizenet/arb/", { data });
}
